export var InternalDateOrder;

(function (InternalDateOrder) {
  InternalDateOrder["DMY"] = "DMY";
  InternalDateOrder["YMD"] = "YMD";
  InternalDateOrder["MDY"] = "MDY";
})(InternalDateOrder || (InternalDateOrder = {}));

export var InternalDateSeparator;

(function (InternalDateSeparator) {
  InternalDateSeparator["Slash"] = "/";
  InternalDateSeparator["Dot"] = ".";
  InternalDateSeparator["Dash"] = "-";
  InternalDateSeparator["Space"] = " ";
})(InternalDateSeparator || (InternalDateSeparator = {}));

export var InternalDateComponentType;

(function (InternalDateComponentType) {
  InternalDateComponentType[InternalDateComponentType["Date"] = 0] = "Date";
  InternalDateComponentType[InternalDateComponentType["Month"] = 1] = "Month";
  InternalDateComponentType[InternalDateComponentType["Year"] = 2] = "Year";
  InternalDateComponentType[InternalDateComponentType["All"] = 3] = "All";
  InternalDateComponentType[InternalDateComponentType["Separator"] = 4] = "Separator";
})(InternalDateComponentType || (InternalDateComponentType = {}));

export var InternalDateValidateCheck;

(function (InternalDateValidateCheck) {
  InternalDateValidateCheck[InternalDateValidateCheck["NotNull"] = 0] = "NotNull";
  InternalDateValidateCheck[InternalDateValidateCheck["Number"] = 1] = "Number";
  InternalDateValidateCheck[InternalDateValidateCheck["Limits"] = 2] = "Limits";
  InternalDateValidateCheck[InternalDateValidateCheck["Native"] = 3] = "Native";
  InternalDateValidateCheck[InternalDateValidateCheck["Range"] = 4] = "Range";
})(InternalDateValidateCheck || (InternalDateValidateCheck = {}));

export function isInternalDateValidateCheck(value) {
  return typeof value === 'number' && Object.values(InternalDateValidateCheck).includes(value);
}
export var InternalDateFirstDayWeek;

(function (InternalDateFirstDayWeek) {
  InternalDateFirstDayWeek[InternalDateFirstDayWeek["Monday"] = 0] = "Monday";
  InternalDateFirstDayWeek[InternalDateFirstDayWeek["Sunday"] = 1] = "Sunday";
  InternalDateFirstDayWeek[InternalDateFirstDayWeek["Saturday"] = 2] = "Saturday";
})(InternalDateFirstDayWeek || (InternalDateFirstDayWeek = {}));

export var InternalDateDayWeek;

(function (InternalDateDayWeek) {
  InternalDateDayWeek[InternalDateDayWeek["Monday"] = 1] = "Monday";
  InternalDateDayWeek[InternalDateDayWeek["Tuesday"] = 2] = "Tuesday";
  InternalDateDayWeek[InternalDateDayWeek["Wednesday"] = 3] = "Wednesday";
  InternalDateDayWeek[InternalDateDayWeek["Thursday"] = 4] = "Thursday";
  InternalDateDayWeek[InternalDateDayWeek["Friday"] = 5] = "Friday";
  InternalDateDayWeek[InternalDateDayWeek["Sunday"] = 6] = "Sunday";
  InternalDateDayWeek[InternalDateDayWeek["Saturday"] = 7] = "Saturday";
})(InternalDateDayWeek || (InternalDateDayWeek = {}));